import { appActions, selectAppEditable } from '../../../../entities/Application'
import {
	useAppDispatch
} from '../../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import {
	useAuthUserRightCheck
} from '../../../../shared/lib/hooks/useAuthUserRightCheck/useAuthUserRightCheck'
import {
	useAppSelector
} from '../../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { MuiSelect } from '../../../../shared/ui/MuiSelect/MuiSelect'
import { SxProps } from '@mui/material'
import { UserRightType } from '../../../../entities/User'
import { SelectChangeEvent } from '@mui/material/Select'

interface AppRightProps {
	label: string
	labelId: 'clients' | 'products' | 'licenses' | 'instances' | 'users',
	actionKey: 'setClientsRights' | 'setProductsRights' | 'setLicensesRights' | 'setInstancesRights' | 'setUsersRights'
	styles: SxProps
}

export const AppRight = (props: AppRightProps) => {
	const { label, labelId, actionKey, styles } = props
	const dispatch = useAppDispatch()
	const hasWriteRight = useAuthUserRightCheck(labelId, UserRightType.WRITE)
	const hasReadRight = useAuthUserRightCheck(labelId, UserRightType.READ_ONLY)
	const { rights } = useAppSelector(selectAppEditable)
	const right = rights[labelId]
	const options = hasWriteRight
		? (labelId === 'users' ? [UserRightType.NO_PERMISSION, UserRightType.READ_ONLY] : UserRightType)
		: hasReadRight
			? [UserRightType.NO_PERMISSION, UserRightType.READ_ONLY]
			: [UserRightType.NO_PERMISSION]

	const handleRightChange = (e: SelectChangeEvent) => {
		dispatch(appActions[actionKey](e.target.value))
	}

	return (
		<MuiSelect
			handleSelectChange={handleRightChange}
			label={label}
			labelId={labelId}
			selectOptions={options}
			value={right}
			size="medium"
			styles={styles}
		/>
	)
}